import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Cards from 'react-credit-cards';
import SubscriptionInfoPresenter from 'presenters/SubscriptionInfoPresenter';
import { Typography, Button } from '@material-ui/core';

import useStyles from './useStyles';

const PaymentMethod = props => {
  const { t } = useTranslation();
  const { subscriptionInfo, onCreditCardModalOpen } = props;
  const classes = useStyles();

  const cardPreviewAttributes = SubscriptionInfoPresenter.cardPreviewAttributes(subscriptionInfo);

  return (
    <div>
      <Typography variant="h2" className={classes.header}>
        {t('components.SubscriptionPage.PaymentMethod.header')}
      </Typography>
      <Cards {...cardPreviewAttributes} preview />
      <Button color="secondary" onClick={onCreditCardModalOpen} className={classes.button}>
        {t('components.SubscriptionPage.PaymentMethod.updateButton')}
      </Button>
    </div>
  );
};

PaymentMethod.propTypes = {
  onCreditCardModalOpen: PropTypes.func.isRequired,
  subscriptionInfo: SubscriptionInfoPresenter.shape().isRequired,
};

export default PaymentMethod;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/PaymentMethod/PaymentMethod.js